module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.13063/images/logos/apple-white.png"